import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { token } = useAuth();

    // 如果沒有 token，返回 null。
    // React Router 會繼續尋找其他匹配的路由，最終會匹配到我們設置的 "*" 路由，從而顯示 404 頁面。
if (!token) {
        // 直接導航到一個專門的 404 頁面路徑，例如 '/not-found'
        // 這會改變瀏覽器的 URL
        return <Navigate to="/not-found" replace />;
    }

    // 如果驗證通過，<Outlet /> 會渲染被包裹的子路由 (如 AdminPage)
    return <Outlet />;
};

export default ProtectedRoute;